"use client";

import { c as _c } from "react/compiler-runtime";
import React, { useId } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTrophy } from "@fortawesome/free-solid-svg-icons";
import { Tooltip } from "react-tooltip";
import useIsMobileDevice from "@/hooks/isMobileDevice";

// Tooltip styles - extracted to prevent re-creation on each render
const TOOLTIP_STYLES = {
  backgroundColor: "#1F2937",
  color: "white",
  padding: "6px 12px",
  fontSize: "12px",
  zIndex: 50,
  boxShadow: "0 4px 16px 0 rgba(0,0,0,0.30), 0 2px 8px 0 rgba(55,55,62,0.25)"
} as const;
interface ProfileWinnerBadgeProps {
  readonly winCount: number;
  readonly title?: string;
  readonly tooltipId?: string;
  readonly onBadgeClick?: () => void;
}
export const ProfileWinnerBadge: React.FC<ProfileWinnerBadgeProps> = t0 => {
  const $ = _c(17);
  const {
    winCount,
    title: t1,
    tooltipId: t2,
    onBadgeClick
  } = t0;
  t1 === undefined ? "View winning artworks" : t1;
  const tooltipId = t2 === undefined ? "winner-badge" : t2;
  const isMobile = useIsMobileDevice();
  const id = useId();
  const uniqueTooltipId = `${tooltipId}-${id}`;
  const [isTooltipOpen, setIsTooltipOpen] = React.useState(false);
  if (winCount === 0) {
    return null;
  }
  let t3;
  if ($[0] !== onBadgeClick) {
    t3 = e => {
      e.preventDefault();
      e.stopPropagation();
      setIsTooltipOpen(false);
      onBadgeClick?.();
    };
    $[0] = onBadgeClick;
    $[1] = t3;
  } else {
    t3 = $[1];
  }
  let t4;
  let t5;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = () => setIsTooltipOpen(true);
    t5 = () => setIsTooltipOpen(false);
    $[2] = t4;
    $[3] = t5;
  } else {
    t4 = $[2];
    t5 = $[3];
  }
  const t6 = `View ${winCount} winning artwork${winCount === 1 ? "" : "s"}`;
  const t7 = !isMobile ? uniqueTooltipId : undefined;
  let t8;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = <FontAwesomeIcon icon={faTrophy} className={"tw-w-3 tw-h-3 md:tw-w-2.5 md:tw-h-2.5 tw-text-amber-400 tw-flex-shrink-0\n        desktop-hover:hover:tw-text-amber-300/90"} />;
    $[4] = t8;
  } else {
    t8 = $[4];
  }
  let t9;
  if ($[5] !== t3 || $[6] !== t6 || $[7] !== t7) {
    t9 = <button onClick={t3} onMouseEnter={t4} onMouseLeave={t5} className={"tw-w-6 tw-h-6 md:tw-w-5 md:tw-h-5 tw-outline-none tw-ring-0 tw-inline-flex tw-items-center tw-justify-center\n       tw-rounded-md tw-border tw-border-solid tw-border-amber-400/20\n        tw-bg-amber-400/10 tw-text-amber-300 tw-text-xs\n        tw-shadow-[inset_0_0_2px_rgba(255,255,255,0.08),0_1px_4px_rgba(0,0,0,0.25)]\n        tw-transition-all tw-duration-200\n        desktop-hover:hover:tw-border-amber-400/30\n        desktop-hover:hover:tw-bg-amber-900/30\n        desktop-hover:hover:tw-scale-[1.05]\n        desktop-hover:hover:tw-shadow-[inset_0_0_3px_rgba(255,255,255,0.12),0_2px_6px_rgba(0,0,0,0.3)]\n        focus:tw-outline-none focus-visible:tw-ring-2 focus-visible:tw-ring-amber-400/50 focus-visible:tw-ring-offset-2"} aria-label={t6} data-tooltip-id={t7}>{t8}</button>;
    $[5] = t3;
    $[6] = t6;
    $[7] = t7;
    $[8] = t9;
  } else {
    t9 = $[8];
  }
  let t10;
  if ($[9] !== isMobile || $[10] !== isTooltipOpen || $[11] !== uniqueTooltipId || $[12] !== winCount) {
    t10 = !isMobile && <Tooltip id={uniqueTooltipId} place="top" positionStrategy="absolute" content={`View ${winCount} winning artwork${winCount === 1 ? "" : "s"}`} delayShow={300} opacity={1} style={TOOLTIP_STYLES} isOpen={isTooltipOpen} />;
    $[9] = isMobile;
    $[10] = isTooltipOpen;
    $[11] = uniqueTooltipId;
    $[12] = winCount;
    $[13] = t10;
  } else {
    t10 = $[13];
  }
  let t11;
  if ($[14] !== t10 || $[15] !== t9) {
    t11 = <>{t9}{t10}</>;
    $[14] = t10;
    $[15] = t9;
    $[16] = t11;
  } else {
    t11 = $[16];
  }
  return t11;
};